function createSlider(selector, options) {
  if (typeof Swiper === "undefined" || !document.querySelector(selector)) return null;
  return new Swiper(selector, options);
}

var swiper = createSlider(".mySwiper-related", {
  loop: false,
  freeMode: true,
  //watchSlidesProgress: true,
  breakpoints: {
    315: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    991: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});

var swiper = createSlider(".mySwiper-review", {
  loop: false,
  freeMode: true,
  //watchSlidesProgress: true,
  breakpoints: {
    315: {
      slidesPerView: 0.7,
      spaceBetween: 20,
    },
    991: {
      slidesPerView: 1.8,
      spaceBetween: 24,
    },
  },
});

var swiper = createSlider(".mySwiper-research", {
  loop: false,
  freeMode: true,
  //watchSlidesProgress: true,
  breakpoints: {
    315: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    991: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});

//---------------------------------------------------------------------

var headerElement = document.querySelector("header");
var stickyElement = document.getElementById("product-sticky-btn");
var scrollFramePending = false;
function updateScrollState() {
  var scroll = window.scrollY;
  if (headerElement) headerElement.classList.toggle("active", scroll >= 300);
  if (stickyElement) stickyElement.classList.toggle("active", scroll >= 500);
  scrollFramePending = false;
}
window.addEventListener("scroll", function () {
  if (scrollFramePending) return;
  scrollFramePending = true;
  window.requestAnimationFrame(updateScrollState);
}, { passive: true });
updateScrollState();

//---------------------------------------------------------------------

var swiper = createSlider(".mySwiper-thum", {
  loop: true,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    1024: {
      slidesPerView: "auto",
      spaceBetween: 8,
    },
  },
});

var swiper2 = createSlider(".mySwiper-main", {
  loop: true,
  thumbs: {
    swiper: swiper,
  },
});

//---------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var shopMenus = document.querySelectorAll(".mid .has-child");
  shopMenus.forEach(function (menuItem) {
    var childMenu = menuItem.querySelector(".child-menu");
    if (!childMenu) return;
    var hideTimer = null;

    menuItem.addEventListener("mouseenter", function () {
      if (hideTimer) clearTimeout(hideTimer);
      childMenu.classList.add("active");
    });

    menuItem.addEventListener("mouseleave", function () {
      hideTimer = setTimeout(function () {
        childMenu.classList.remove("active");
      }, 150);
    });
  });

  var scrollTriggers = document.querySelectorAll("[data-scroll-target]");
  scrollTriggers.forEach(function (scrollTrigger) {
    scrollTrigger.addEventListener("click", function (e) {
      var href = scrollTrigger.getAttribute("href") || "";
      e.preventDefault();
      var targetId = scrollTrigger.getAttribute("data-scroll-target");
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (!target) {
        if (href) window.location.href = href;
        return;
      }
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  const btnOpen = document.getElementById("view-supplement");
  const overlay = document.getElementById("overlay");
  const panel = document.getElementById("product-supplement");
  const btnClose = document.getElementById("close-supplement");

  if (btnOpen && overlay && panel) {
    // เปิด
    btnOpen.addEventListener("click", function () {
      overlay.classList.add("active");
      panel.classList.add("active");
    });

    // ปิดเมื่อคลิ๊ก overlay (แต่ไม่ใช่คลิ๊กใน panel)
    overlay.addEventListener("click", function (e) {
      if (!panel.contains(e.target)) {
        overlay.classList.remove("active");
        panel.classList.remove("active");
      }
    });

    // ปิดด้วยปุ่ม close
    if (btnClose) {
      btnClose.addEventListener("click", function () {
        overlay.classList.remove("active");
        panel.classList.remove("active");
      });
    }
  }

  initProductQuantityPicker();
});

//---------------------------------------------------------------------

function initProductQuantityPicker() {
  var quantityContainer = document.querySelector(".quantity");
  var variantsScript = document.querySelector("[data-product-variants]");

  if (!quantityContainer || !variantsScript) return;

  var priceEl = document.querySelector("[data-product-price]");
  var stickyPriceEl = document.querySelector("[data-sticky-price]");
  var addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
  var variantData;

  try {
    variantData = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error("Failed to parse product variant data.", error);
    return;
  }

  if (!variantData || !Array.isArray(variantData.variants) || !variantData.variants.length) return;

  var variants = variantData.variants;
  var selectedVariant =
    variants.find(function (variant) {
      return String(variant.id) === String(variantData.selectedVariantId);
    }) ||
    variants.find(function (variant) {
      return variant.available;
    }) ||
    variants[0];

  function updateSelectedVariant(variant) {
    if (!variant) return;

    selectedVariant = variant;

    if (priceEl) {
      priceEl.textContent = variant.price;
    }

    if (stickyPriceEl) {
      stickyPriceEl.textContent = variant.price;
    }

    addToCartButtons.forEach(function (button) {
      button.setAttribute("data-variant-id", variant.id);
      button.classList.toggle("soldout", !variant.available);
    });

    quantityContainer.querySelectorAll("[data-quantity-variant-id]").forEach(function (optionEl) {
      var isActive = String(optionEl.getAttribute("data-quantity-variant-id")) === String(variant.id);
      optionEl.classList.toggle("active", isActive);
    });
  }

  quantityContainer.innerHTML = "";

  variants.forEach(function (variant) {
    var optionEl = document.createElement("div");
    optionEl.textContent = variant.label;
    optionEl.setAttribute("data-quantity-variant-id", variant.id);
    optionEl.classList.toggle("soldout", !variant.available);

    if (variant.available) {
      optionEl.addEventListener("click", function () {
        updateSelectedVariant(variant);
      });
    }

    quantityContainer.appendChild(optionEl);
  });

  updateSelectedVariant(selectedVariant);
}

//---------------------------------------------------------------------
